import { RoundChartElementHandler } from './round-chart.element-handler';

export class DoughnutChartElementHandler extends RoundChartElementHandler<'chartDoughnut'> {
  readonly type = 'chartDoughnut';
}
